export enum FilterOperator{
  Contains,
  Equal,
  NotEqual,
  LessThan,
  LessThanOrEqual,
  GreaterThan,
  GreaterThanOrEqual,
  InList,
  NotInList,
  InBetween
}

export enum SortOperator {
  ASCENDING,
  DESCENDING
}

export interface LookupFilter {
  value: string;
  filter_operator: FilterOperator;
  filter_value: string | number | boolean;
}
